import { FC, ReactNode } from 'react';

import cs from 'classnames';
import * as Flags from 'country-flag-icons/react/3x2';

import { getCountryCodeByName } from 'utils/countries';

import { Country, Location } from 'types/commons';

import { flagCodes } from 'constants/flagCodes';
import { FALLBACK_VALUE } from 'constants/uiSettings';

import styles from './LocationDisplay.module.scss';

interface LocationDisplayProps {
  location: Partial<Location> | null;
  countryData?: Partial<Country> | null;
  className?: string;
  noFlag?: boolean;
  countryCode?: string | null;
  fallbackValue?: string;
  address?: string | null;
  isFlagAtEnd?: boolean;
}

const LocationDisplay: FC<LocationDisplayProps> = ({
  location,
  countryData,
  className,
  noFlag = false,
  countryCode,
  fallbackValue = FALLBACK_VALUE,
  address = '',
  isFlagAtEnd
}): ReactNode | null => {
  const { country, state, city } = location ?? {};

  const resolvedCountryCode =
    countryCode || countryData?.code || getCountryCodeByName(country || null);

  if (!country && !state && !city && !countryData && !address) {
    return fallbackValue;
  }

  const FlagIcon =
    resolvedCountryCode && !noFlag && flagCodes.includes(resolvedCountryCode)
      ? Flags[resolvedCountryCode as keyof typeof Flags]
      : null;

  const text = [city, state, countryData?.name, address]
    .filter(Boolean)
    .join(', ');

  return (
    <div
      className={cs(styles.countryPreview, className, {
        [styles.reversed]: isFlagAtEnd
      })}
      title={text}
    >
      {FlagIcon && <FlagIcon className={styles.countryCode} />}
      <div className={styles.textWrapper}>{text}</div>
    </div>
  );
};

export default LocationDisplay;
